import React from 'react'
import MyListBlock from '../../../../../UI/list/MyListBlock'
import { useState } from 'react'
import { useEffect } from 'react'

const WriteOffActItemJunk = ({ writeOffActItem }) => {

    const [list, setList] = useState([])
    const [listSecond, setListSecond] = useState([])

    useEffect(() => {
        setListItems()
        setListSecondItems()
    }, [writeOffActItem])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'ID',
            value: writeOffActItem.id
        })
        listTemp.push({
            name: 'Назва',
            value: writeOffActItem.name
        })
        listTemp.push({
            name: 'Кількість',
            // value: writeOffActItem.count + ' ' + unitMeasureShortText[writeOffActItem.unitMeasure]
            value: ''
        })
        listTemp.push({
            name: 'Назва в акті',
            value: ''
                // <ChangeNameInActButton
                //     writeOffActItem={writeOffActItem}
                // />
        })
        listTemp.push({
            name: 'Номенклатурний номер',
            value: ''
                // <ChangeNomenclatureNumberButton
                //     writeOffActItem={writeOffActItem}
                // />
        })

        setList(listTemp)
    }

    const setListSecondItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Вартість',
            value: ''
                // <ChangePriceWriteOffActItemButton
                //     writeOffActItem={writeOffActItem}
                // />
        })
        
        listTemp.push({
            name: 'Дії з позицією',
            value: 
                <>
                    {/* <WriteOffActItemButton 
                        writeOffActItem={writeOffActItem}
                    /> */}
                </> 
                // <DeleteBillItemButton
                //     supplyBillItem={supplyBillItem}
                // />
        })

        setListSecond(listTemp)
    }

  return (
    <div className='writeOffActItem__junk'>
        <MyListBlock
                className={'supplyOrderView__topBlock myListBlock__wrap'}
                text={`Брухт`}
                list={list} 
            />
        {/* </div> */}
        <MyListBlock 
            className={'supplyOrderView__topBlock w250'}
            // text={`Позиція №${index + 1}`}
            list={listSecond} 
        />
    </div>
  )
}

export default WriteOffActItemJunk